/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Modular_Wizard_Field_LockedInputs */



/**
* | output |
* | --- |
* | "Set when you signed in. To use another address, start the connection again." |
*
* @param {Spaces_Modular_Wizard_Field_LockedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_modular_wizard_field_locked = /** @type {((inputs?: Spaces_Modular_Wizard_Field_LockedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Modular_Wizard_Field_LockedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beim Anmelden festgelegt. Für eine andere Adresse beginne die Verbindung neu.")
	return /** @type {LocalizedString} */ ("Set when you signed in. To use another address, start the connection again.")
});